var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSearchLine = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0203 11.0779L14.8755 13.933L13.9327 14.8758L11.0775 12.0207C10.0509 12.842 8.74901 13.3333 7.33301 13.3333C4.02101 13.3333 1.33301 10.6453 1.33301 7.33334C1.33301 4.02134 4.02101 1.33334 7.33301 1.33334C10.645 1.33334 13.333 4.02134 13.333 7.33334C13.333 8.74934 12.8417 10.0513 12.0203 11.0779ZM10.6828 10.5832C11.498 9.74308 11.9997 8.59708 11.9997 7.33334C11.9997 4.75501 9.91134 2.66668 7.33301 2.66668C4.75467 2.66668 2.66634 4.75501 2.66634 7.33334C2.66634 9.91168 4.75467 12 7.33301 12C8.59674 12 9.74274 11.4983 10.5829 10.6831L10.6828 10.5832Z",
    fill: "#4C5552"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSearchLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/search-line.daa650f6.svg";
export { ForwardRef as ReactComponent };